<p>generic-detail works!</p>
